import React from "react";
import ReportView from "../components/ReportView";
import { Tag, fmt } from "../components/UI";

const STATUS_TONE = { active: "emerald", pending: "amber", rejected: "rose", reversed: "rose" };

const columns = [
  { key: "order_ref", label: "Order ID", filter: "text" },
  { key: "physio_name", label: "Physio", filter: "text" },
  { key: "mobile", label: "Mobile", filter: "text" },
  { key: "erp_outlet_id", label: "ERP Outlet ID", filter: "text" },
  { key: "shop_type", label: "ShopType", filter: "text", render: (r) => r.shop_type || "—" },
  { key: "amount", label: "Net Value", align: "right", render: (r) => (r.amount != null ? `₹${fmt(Math.round(r.amount))}` : "—") },
  { key: "points", label: "Points", align: "right", render: (r) => fmt(r.points || 0) },
  { key: "status", label: "Status", filter: "select", options: ["active", "pending", "rejected"], render: (r) => <Tag tone={STATUS_TONE[r.status] || "slate"}>{r.status || "—"}</Tag> },
  { key: "dispatch_status", label: "Dispatch", filter: "text" },
  { key: "order_date", label: "Order Date", filter: "text" },
  { key: "dse", label: "DSE", filter: "text", accessor: (r) => r.dse_name || r.dse || "—", render: (r) => r.dse_name || r.dse || "—" },
];

const monthOf = (s) => (s ? String(s).slice(0, 7) : null);

const charts = [
  { id: "txn-value-trend", type: "area", title: "Net value over time", subtitle: "Monthly order value (₹)", valueLabel: "Net value (₹)", groupBy: (r) => monthOf(r.order_date), value: (r) => r.amount || 0, sort: "time", color: "#0F766E" },
  { id: "txn-status-mix", type: "donut", title: "Order status mix", valueLabel: "Orders", groupBy: (r) => r.status },
  { id: "txn-top-physios", type: "bar", title: "Top physios by points", valueLabel: "Points", groupBy: (r) => r.physio_name, value: (r) => r.points || 0, sort: "value_desc", limit: 10, labelWidth: 130 },
];

export default function TransactionReport() {
  return (
    <ReportView
      kicker="Field Assist · Stock & Sales"
      title="Transaction Report"
      subtitle="Every order pulled from the Field Assist Stock & Sales feed (new orders + dispatch-status updates). Tap Sync for a live pull. Filter by date range and mobile number."
      fetchPath="/reports/transactions"
      syncPath="/integrations/field-assist/sync"
      statusPath="/integrations/field-assist/status"
      columns={columns}
      charts={charts}
      searchableKeys={["order_ref", "physio_name", "mobile", "erp_outlet_id"]}
      exportFilename="transaction-report"
      testId="transaction-report"
      syncLabel="Sync transactions"
    />
  );
}
